<template>
  <div class="row">
    <div class="col-12 col-md-4 col-lg-3">
      <!-- <q-input
        class="q-pa-xs"
        v-if="question.name == 1"
        :label="`Name ${required ? '*' : ''}`"
        v-model="formData.name"
        v-bind="siteCFG.fields.general"
        :required="required"
        @blur="save"
      >
      </q-input> -->
      <q-input
        @blur="save"
        :required="required"
        class="q-pa-xs"
        v-if="question.name == 1"
        v-model="formData.name"
        ref="input"
        v-bind="siteCFG.fields.general"
        @keydown="keydownListener"
        :label="`Name ${required ? '*' : ''}`"
        :disable="$moment() < $moment(competition.entriesCloseDate) == false"
      >
      </q-input>
      <q-menu
        no-focus
        no-refocus
        :value="showMenu"
        anchor="bottom middle"
        self="top middle"
        fit
      >
        <q-list>
          <q-item
            v-for="item in filteredItems"
            :key="item.name"
            @click="selectItem(item)"
            clickable
          >
            <q-item-section>
              <q-item-label>
                {{ item.firstName }} {{ item.lastName }}
              </q-item-label>
              <q-item-label caption>{{ item.crm_id }}</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </div>
    <div class="col-12 col-md-4 col-lg-3">
      <q-input
        class="q-pa-xs"
        v-if="question.mobile == 1"
        :label="`Mobile ${required ? '*' : ''}`"
        v-model="formData.mobile"
        v-bind="siteCFG.fields.general"
        :required="required"
        @blur="save"
        :disable="$moment() < $moment(competition.entriesCloseDate) == false"
      >
      </q-input>
    </div>
    <div class="col-12 col-md-4 col-lg-6">
      <q-input
        class="q-pa-xs"
        v-if="question.email == 1"
        :label="`Email ${required ? '*' : ''}`"
        v-model="formData.email"
        v-bind="siteCFG.fields.general"
        :required="required"
        @blur="save"
      >
      </q-input>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      question: {
        default: null,
      },
      index: {
        default: 0,
        type: Number,
      },
      required: {
        default: true,
        type: Boolean,
      },
      competition_id: {
        default: null,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        questionAnswers: "questions/answersListForCompetition",
        questionAnswersLoading: "questions/answersListForCompetitionLoading",
        associationMembers: "associations/members",
        competition: "competitions/current",
      }),
      filteredItems() {
        return this.associationMembers.filter((item) => {
          let text = this.formData.name ? this.formData.name.toLowerCase() : "";
          let filterItem = `${item.firstName.toLowerCase()} ${item.lastName.toLowerCase()}`;
          return filterItem.indexOf(text) > -1;
        });
      },
      showMenu() {
        if (this.$refs.input) {
          return this.formData.name ? this.formData.name.length > 0 : false;
        } else {
          return false;
        }
      },
    },
    watch: {
      questionAnswers: function () {
        this.init();
      },
    },
    data: () => ({
      formData: {
        name: "",
        mobile: "",
        email: "",
      },
      associationMemberSearch: "",
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let answer = this.questionAnswers.find(
          (qa) =>
            qa.competitionQuestions_id == this.question.id &&
            qa.index == this.index
        );
        if (answer) {
          this.formData.name = answer.name;
          this.formData.email = answer.email;
          this.formData.mobile = answer.mobile;
          this.formData.id = answer.id;
        }
      },
      save() {
        // The timeout is here because of the blur event when clicking the option being triggered
        setTimeout(() => {
          let payload = this.formData;
          payload.index = this.index;
          payload.competitionQuestions_id = this.question.id;
          payload.associations_id = this.currentUserData.currentAssociation_id;
          this.$store.dispatch("questions/saveAnswer", payload).then((result) => {
            if (result.Result == "Success") {
              this.$store.dispatch("questions/loadAnswersForCompetition", {
                id: this.competition_id,
                entries: 1,
              });
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        }, 300);
      },
      selectItem(item) {
        this.formData.name = `${item.firstName} ${item.lastName}`;
        this.formData.mobile = item.mobilePhone;
        this.formData.email = item.emailAddress;
        this.$refs.input.focus();
      },
      keydownListener(event) {
        if (event.which == 9) {
          event.preventDefault();
          this.selectItem(this.filteredItems[0]);
        }
      },
    },
  };
</script>
